import DataGrid from "react-data-grid";

import styled from "styled-components/macro";

// for light theme
export const rdgThemeClassname = "rdg-light";

export const paginationHeight = 40;

export const StyledGrid = styled(DataGrid)`
  overflow: hidden;

  &:hover {
    overflow: scroll;
  }

  // Highlighting individual cells on hover.
  .rdg-cell {
    &:hover {
      background-color: rgba(220, 233, 246, 1);
    }
  }
`;

export const AlertContainer = styled.div`
  position: absolute;
  left: 0;
  top: 86px;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #cccccc8d;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
`;
